



































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import AbpConst from "@/lib/appconst";
import Address from "@/store/entities/address";
import ProvinceForSelect from "@/store/entities/provinceForSelect";
import DistrictForSelect from "@/store/entities/districtForSelect";
import WardForSelect from "@/store/entities/wardForSelect";
import _ from "lodash";
@Component
export default class ComponentAddressModal extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: new Address() }) selectedAddress: Address;
  provinces: ProvinceForSelect[] = new Array<ProvinceForSelect>();
  districts: DistrictForSelect[] = new Array<DistrictForSelect>();
  wards: WardForSelect[] = new Array<WardForSelect>();
  objectSelectedAddress: Address = new Address();
  normalizeId(value) {
    if (_.isNil(value) || value === "") return null;
    const normalizedValue = Number(value);
    return Number.isFinite(normalizedValue) && normalizedValue > 0
      ? normalizedValue
      : null;
  }

  async onchangeProvince(value?, preserveWard: boolean = false) {
    this.objectSelectedAddress.provinceId = this.normalizeId(
      _.isNil(value) ? this.objectSelectedAddress.provinceId : value,
    );
    this.objectSelectedAddress.districtId = null;
    this.objectSelectedAddress.districtCode = null;

    if (
      _.isNil(this.objectSelectedAddress.provinceId) ||
      this.objectSelectedAddress.provinceId <= 0
    ) {
      this.wards = [];
      this.objectSelectedAddress.wardId = null;
      return;
    }

    const currentWardId = this.normalizeId(this.objectSelectedAddress.wardId);
    this.objectSelectedAddress.wardId = preserveWard ? currentWardId : null;

    await this.$store
      .dispatch({
        type: "geoLocation/getWardsForSelectOfProvince",
        data: {
          provinceId: this.objectSelectedAddress.provinceId,
        },
      })
      .then((res) => {
        this.wards = res;
        if (preserveWard) {
          const matchedWard = this.wards.find((item) => item.id == currentWardId);
          this.objectSelectedAddress.wardId = matchedWard
            ? currentWardId
            : null;
        }
      });

    // await this.$store
    //   .dispatch({
    //     type: "geoLocation/getDistrictsForSelectOfProvince",
    //     data: {
    //       provinceId: this.objectSelectedAddress.provinceId,
    //     },
    //   })
    //   .then((res) => {
    //     this.districts = res;
    //     this.onchangeDistrict();
    //   });
  }

  // async onchangeDistrict() {
  //   if (
  //     _.isNil(this.objectSelectedAddress.districtId) ||
  //     this.objectSelectedAddress.districtId <= 0
  //   )
  //     return;

  //   await this.$store
  //     .dispatch({
  //       type: "geoLocation/getWardsForSelectOfDistrict",
  //       data: {
  //         districtId: this.objectSelectedAddress.districtId,
  //       },
  //     })
  //     .then((res) => {
  //       this.wards = res;
  //       this.onchangeWard();
  //     });
  // }

  async onchangeWard(value?) {
    this.objectSelectedAddress.wardId = this.normalizeId(
      _.isNil(value) ? this.objectSelectedAddress.wardId : value,
    );

    if (
      _.isNil(this.objectSelectedAddress.wardId) ||
      this.objectSelectedAddress.wardId <= 0
    )
      return;
  }

  save() {
    this.objectSelectedAddress.provinceId = this.normalizeId(
      this.objectSelectedAddress.provinceId,
    );
    this.objectSelectedAddress.districtId = null;
    this.objectSelectedAddress.districtCode = null;
    this.objectSelectedAddress.wardId = this.normalizeId(
      this.objectSelectedAddress.wardId,
    );

    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        Object.assign(this.selectedAddress, this.objectSelectedAddress);
        var _selectedObjectAddress = this.selectedObjectAddress;
        this.selectedAddress.fullAddress = _.get(
          _selectedObjectAddress,
          "fullAddress",
        );
        this.selectedAddress.provinceCode = _.get(
          _selectedObjectAddress,
          "provinceCode",
        );
        // this.selectedAddress.districtCode = _.get(
        //   _selectedObjectAddress,
        //   "districtCode",
        // );
        this.selectedAddress.wardCode = _.get(
          _selectedObjectAddress,
          "wardCode",
        );
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  get selectedObjectAddress() {
    if (Util.isNull(this.objectSelectedAddress)) return "";
    this.objectSelectedAddress.countryCode = AbpConst.defaultCountry;
    const province = this.provinces.find(
      (p) => p.id == this.objectSelectedAddress.provinceId,
    );
    const district = this.districts.find(
      (p) => p.id == this.objectSelectedAddress.districtId,
    );
    const ward = this.wards.find(
      (p) => p.id == this.objectSelectedAddress.wardId,
    );
	    if (
	      _.isNil(this.objectSelectedAddress.addressNo) ||
	      _.isEmpty(this.objectSelectedAddress.addressNo)
	    ) {
	      return {
	        fullAddress: Util.buildAddress([
	          _.get(ward, "name"),
	          _.get(district, "name"),
	          _.get(province, "name"),
	        ]),
	        provinceCode: _.isNil(province) ? null : province.code,
	        districtCode: _.isNil(district) ? null : district.code,
	        wardCode: _.isNil(ward) ? null : ward.code,
	      };
	    }
	    return {
	      fullAddress: Util.buildAddress([
	        this.objectSelectedAddress.addressNo,
	        _.get(ward, "name"),
	        _.get(district, "name"),
	        _.get(province, "name"),
	      ]),
	      provinceCode: _.isNil(province) ? null : province.code,
	      districtCode: _.isNil(district) ? null : district.code,
	      wardCode: _.isNil(ward) ? null : ward.code,
	    };
	  }
  cancel() {
    this.selectedAddress = new Address();
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      if (
        Util.isNull(this.$store.state.geoLocation.provincesForSelect) ||
        this.$store.state.geoLocation.provincesForSelect.length <= 0
      ) {
        await this.$store.dispatch({
          type: "geoLocation/getProvincesForSelect",
        });
      }

      this.provinces = (
        this.$store.state.geoLocation.provincesForSelect || []
      ).filter(
        (p) => p.countryCode && p.countryCode == AbpConst.defaultCountry,
      );

      if (Util.isNull(this.selectedAddress)) {
        this.objectSelectedAddress = new Address();
      } else {
        this.objectSelectedAddress = Object.assign(
          new Address(),
          this.selectedAddress,
          {
            provinceId: this.normalizeId(this.selectedAddress.provinceId),
            districtId: this.normalizeId(this.selectedAddress.districtId),
            wardId: this.normalizeId(this.selectedAddress.wardId),
          },
        );

        if (
          !_.isNil(this.objectSelectedAddress.provinceId) &&
          this.objectSelectedAddress.provinceId > 0
        ) {
          await this.onchangeProvince(undefined, true);
        }
      }
    }
  }
  async mounted() {
    if (
      Util.isNull(this.$store.state.geoLocation.provincesForSelect) ||
      this.$store.state.geoLocation.provincesForSelect.length <= 0
    ) {
      await this.$store.dispatch({
        type: "geoLocation/getProvincesForSelect",
      });
    }
  }
  validateAddressNo(rule, value, callback) {
    if (
      !_.isNil(this.objectSelectedAddress.addressNo) &&
      !_.isEmpty(this.objectSelectedAddress.addressNo) &&
      this.objectSelectedAddress.addressNo.length > 255
    ) {
      callback(
        new Error(this.L("Error.AddressNoLessThanOrEqual", undefined, "255")),
      );
    } else {
      callback();
    }
  }
  validateLocationRequired(rule, value, callback) {
    if (_.isNil(this.normalizeId(value))) {
      callback(
        new Error(this.L("Error.RequiredField0", undefined, rule.fieldLabel)),
      );
      return;
    }

    callback();
  }
  rule = {
    provinceId: [
      {
        validator: (rule, value, callback) =>
          this.validateLocationRequired(
            {
              ...rule,
              fieldLabel: this.L("Province"),
            },
            value,
            callback,
          ),
        trigger: "change",
      },
    ],
    // districtId: [
    //   {
    //     required: true,
    //     type: "number",
    //     message: this.L("Error.RequiredField0", undefined, this.L("District")),
    //     trigger: "blur",
    //   },
    // ],
    wardId: [
      {
        validator: (rule, value, callback) =>
          this.validateLocationRequired(
            {
              ...rule,
              fieldLabel: this.L("Ward"),
            },
            value,
            callback,
          ),
        trigger: "change",
      },
    ],
    addressNo: [
      {
        validator: this.validateAddressNo,
        trigger: "change",
      },
    ],
  };
}
